import React from 'react';
import Item from './Item';
import Loading from '../bits/Loading';

class ItemsList extends React.Component {

    render(){

            if(!this.props.items) {
                return(
                    <Loading />
                )
            }

        let renderedList = this.props.items.map((item, index) => {
            let k = 'Item-' + index + '-'+item.id;

                return <Item key={k} onItemSelect={this.props.onItemSelect} item={item} selected={(this.props.selectedItem === item.id ? true : false)}/>

        });

        return(
            <div className="row esd-image-list">{renderedList}</div>
        )
    }
}


export default ItemsList;